/**
 * This file contains the code for creating or editing the quiz
 */

import React from "react";
import swal from "sweetalert";
import { themeArr, quizTypeArr } from "../global";
import { ImageUpload } from "../components/imageupload";
import { QueTable } from "../forms/questiontable";
import { Queform } from "../forms/questionform";
import ReactTooltip from "react-tooltip";
import QuizeThemeFirst from "../templates/theme_1";
import QuizeThemeSecond from "../templates/theme_2";
import { NotificationManager } from "react-notifications";
import ColorPicker from "../picker/colorpicker";
import CustomTextEditor from "../components/customtexteditor";
import {quiztypeenum} from "../enums/quiztypeenum";
import { PersonalityForm } from "./personalityform";
import { QueCategoryForm } from "./quecategoryform";
import { SeoSettingForm } from "./seosettingform";

import * as DOMPurify from "dompurify";
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  LinkedinShareButton,
  LinkedinIcon,
  WhatsappShareButton,
  WhatsappIcon,
  EmailShareButton,
  EmailIcon,
} from "react-share";


var defaultBackgroundImage = "";
var shareBtnSize = 36;
var shareUrl = "";


export class QueSettingForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      queformActive: this.props.queformActive,
      quiz: this.props.quiz,
      user: this.props.user,
      quetable: this.props.quetable,
      selectedQue: this.props.selectedQue,
      updateQuiz: this.props.updateQuiz,
    };
    this.onClickSaveQue = this.onClickSaveQue.bind(this);
    this.onClickEditQue = this.onClickEditQue.bind(this);
    this.onClickDelQue = this.onClickDelQue.bind(this);
    this.showQueForm = this.showQueForm.bind(this);
    this.updateLogicBranchingFlag = this.updateLogicBranchingFlag.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      queformActive: nextProps.queformActive,
      quiz: nextProps.quiz,
    });
  }

  showQueForm(event) {
    var tempque = {
      title: "",
      quetype: "MCSA",
      quizid: this.state.quiz != null ? this.state.quiz.quizid : null,
      queimg: null,
      queid: null,
      jsonmarks: "[]",
      jsonans: '["",""]',
      jsonansimg: "[]",
      jsonpersonality: "[]",
      action: "",
    };
    this.setState({ selectedQue: tempque }, () => {
      this.props.updateSelectedQue(tempque);
      this.props.activateQueForm();
    });
  }

  onClickSaveQue(event, selectedque, flag) {
    var queid = event.target.getAttribute("data-id");
    var tempquiz = this.state.quiz;
    if (queid != null) {
      var index = queid - 1;
      if (tempquiz == null) {
        tempquiz = {};
        tempquiz.que = {};
      } else if (tempquiz.que == null) {
        tempquiz.que = {};
      }
      selectedque.action = "";
      var tempque = Object.values(tempquiz.que).filter(
        (element) => element.queid == queid
      );
      if (tempque != null && tempque.length > 0) {
        tempque[0] = selectedque;
        //tempquiz.que.index = selectedque;
      }
    } else {
      var index = 0;
      if (tempquiz == null) {
        tempquiz = {};
        //tempquiz.que = [];
        tempquiz.que = {};
        tempquiz.quizid = null;
      } else if (tempquiz.que == null) {
        //tempquiz.que = [];
        tempquiz.que = [];
      }

      //if(tempquiz.que!=null && tempquiz.que.length==0)
      if (tempquiz.que != null) {
        //index = tempquiz.que.length;
        if (tempquiz.que.length == null || tempquiz.que.length == 0) {
          index = 0;
        } else {
          var queidArr = tempquiz.que.map((item, counter) => item.queid);
          //var keys = Object.values(tempquiz.que);
          if (queidArr == null || queidArr.length == 0) {
            index = 0;
          }
          var keys = Object.values(queidArr);
          if (keys.length == 0) {
            index = 0;
          } else {
            index = Math.max.apply(
              Math,
              keys.map(function (o) {
                return o;
              })
            );
          }
        }
      }
      selectedque.queid = "" + (index + 1);
      selectedque.quizid = tempquiz.quizid;
      selectedque.action = "";
      //tempquiz.que.queid = selectedque;
      tempquiz.que.push(selectedque);
    }

    if (flag) {
      var tempque = {
        title: "",
        quetype: "MCSA",
        quizid: this.state.quiz.quizid,
        queimg: null,
        queid: null,
        jsonmarks: "[]",
        jsonans: '["",""]',
        jsonansimg: "[]",
        action: "",
      };
      //this.setState({selectedQue: tempque});
    }
    this.props.updateQuiz(tempquiz);
    this.props.closeQueForm();
    // alert("question saved!");
    var self = this;
    var quizid = this.state.quiz["quizid"];
    //var postdata = JSON.stringify(tempquiz.que);
    var postdata = JSON.stringify(Object.values(tempquiz.que));
    var queryurl = this.props.basepath + "question/saveque/" + quizid;
    fetch(queryurl, {
      method: "post",
      credentials: "include",
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
      body: postdata,
    }).then(function (response) {
      return response.json();
    }).then(function (response) {
      self.setState({ showLoaderFlag: false });
      if (response && response.status ==200 && response.data) {
        NotificationManager.success("Question", "Question saved successfully");
      }else{
        NotificationManager.error("Server error: ", "Question failed to be saved");
      }
    }).catch(err=>{
      NotificationManager.error("Server error: " , err.message)
    });
    //swal("Question saved!", "", "success");
  }

  onClickEditQue(event) {
    var queid = event.target.getAttribute("data-id");

    //var selQue = this.state.quiz.que[index];
    var que = Object.values(this.state.quiz.que);
    //var selQue = this.state.quiz.que.index;
    var selQue = que.filter((element) => element.queid == queid);
    if (selQue != null && selQue.length > 0) {
      this.setState({ selectedQue: selQue[0] }, this.props.activateQueForm);
    }
  }

  onClickDelQue(event) {
    var queid = event.target.getAttribute("data-id");
    var quizid = this.state.quiz["quizid"];
    var self = this;
    swal({
      title: "Delete Question",
      text: "Are you sure you want to delete this question? This question and all related data will be permanently deleted.",
      type: "warning",
      buttons: { cancel: true, text: "Yes, Delete it!!", closeModal: false },
      icon: "warning",
    }).then(function (isConfirm) {
      if (isConfirm) {
        var queryurl =
          self.props.basepath + "question/deleteque/" + quizid + "/" + queid;
        fetch(queryurl, {
          method: "get",
          credentials: "include",
        }).then(function (response) {
          return response.json();
        }).then((response) => {
          if (response && response.status ==200 && response.data) {
            var quizArr = self.state.quiz;
            var queArr = quizArr.que;
            queArr = queArr.filter(element => element.queid !== parseInt(queid));
            quizArr.que = queArr;
            self.setState({ quiz: quizArr }, () => {
              NotificationManager.success("Question Deleted", "Question has been deleted successfully.");
            });
          }else{
            NotificationManager.error("Server error: ",response.message);
          }
        }).catch(err=>{
          NotificationManager.error("Server error: " , err.message)
        });
      }
    });
  }

  updateLogicBranchingFlag(e) {
    var quiz = this.state.quiz;

    if (e.target.checked) {
      swal({
        title: "Logic Branching",
        text: "Please ensure all your questions are added before you create logic branching.",
        type: "info",
        buttons: { cancel: true, text: "Ok", closeModal: false },
        icon: "info",
        className: "logic-branching-confirm",
      }).then((willDelete, e) => {
        if (willDelete) {
          quiz.islogicbranchingenabled = 1;
          this.setState({ quiz });
        }
      });
    } else {
      swal({
        title: "Are you sure?",
        text: "All your branching logic will get reset.",
        icon: "warning",
        buttons: { cancel: true, text: "Ok", closeModal: false },
        className: "logic-branching-confirm",
        dangerMode: true,
      }).then((willDelete, e) => {
        if (willDelete) {
          quiz.logicalbranches = null;
          quiz.islogicbranchingenabled = 0;
          this.setState({ quiz });
        } else {
          quiz.islogicbranchingenabled = 1;
          this.setState({ quiz });
          return false;
        }
      });
    }
    if (quiz == null) {
      quiz = {};
    }

    this.setState({ quiz });
  }

  render() {
    return (
      <div>
        <div className={`col-md-12 ${this.state.queformActive ? "hide" : ""}`}>
          <QueTable
            quiz={this.state.quiz}
            tableItems={this.state.quetable}
            // tableTitle="Question Table"
            quizid={this.state.quiz != null ? this.state.quiz.quizid : null}
            // addQue={this.addQue}
            updateQuiz={this.props.updateQuiz}
            editQue={this.onClickEditQue}
            delQue={this.onClickDelQue}
            addAns={this.props.addAns}
            delAns={this.props.delAns}
            selectedQue={this.props.selectedQue}
            reportQue={this.props.reportQue}
            saveQuiz={this.props.saveQuiz}
            showQueForm={this.showQueForm}
            handleQuePreview={this.props.handleQuePreview}
          />
        </div>
        <div className="col=md-12">
          <Queform
            active={this.state.queformActive}
            modaltitle="Question Wizard"
            closeQueForm={this.props.closeQueForm}
            saveQue={this.onClickSaveQue}
            selectedQue={this.props.selectedQue}
            quetype={
              this.state.selectedQue == null ||
              this.state.selectedQue.quetype == null
                ? "MCSA"
                : this.state.selectedQue.quetype
            }
            quiz={this.state.quiz}
            basepath={this.props.basepath}
            user={this.props.user}
            updateQue={this.props.updateQue}
            updateAns={this.props.updateAns}
          />
        </div>
        {this.state.quiz.quiztype != quiztypeenum.graded_quiz && this.state.quiz.quiztype != quiztypeenum.category_graded_quiz_with_personality ? (
          <div className="row">
            <div className="col-md-12">
              <div className="checkbox">
                <div className="Sign-In-Label">
                  <div
                    className="col-md-12"
                    style={{ marginLeft: 5, height: 20 }}
                  >
                    <input
                      type="checkbox"
                      onChange={this.updateLogicBranchingFlag}
                      name="islogicbranchingenabled"
                      checked={
                        this.state.quiz == null ||
                        this.state.quiz.islogicbranchingenabled == 1
                          ? true
                          : false
                      }
                    />
                    <div style={{ marginTop: 2.5 }}>
                      <span> Enable Logic Branching</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}



